/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getConvos.defs.js'
export { main as default } from './getConvos.defs.js'
